type PaginationProps = {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  pageSize: number;
  onPageChange: (page: number) => void;
};

export function Pagination({
  currentPage,
  totalPages,
  totalItems,
  pageSize,
  onPageChange,
}: PaginationProps) {
  if (totalPages <= 1) {
    return null;
  }

  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalItems);

  const canGoPrevious = currentPage > 1;
  const canGoNext = currentPage < totalPages;

  return (
    <nav className="pagination" aria-label="Навигация по страницам">
      <div className="pagination__info">
        Показаны {startItem}–{endItem} из {totalItems}
      </div>
      <div className="pagination__controls">
        <button
          type="button"
          className="button button--secondary button--sm"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={!canGoPrevious}
          aria-label="Предыдущая страница"
        >
          ← Назад
        </button>
        <span className="pagination__pages" aria-current="page">
          Страница {currentPage} из {totalPages}
        </span>
        <button
          type="button"
          className="button button--secondary button--sm"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={!canGoNext}
          aria-label="Следующая страница"
        >
          Вперёд →
        </button>
      </div>
    </nav>
  );
}
